module.exports = __webpack_public_path__ + "media/images/decorations/decoration-1-3f1d0227cf68081cd688dfb1c8621a7c.svg";